import React, { useState } from 'react'
import Maindadhboard from './MainDashboard'
import AmuAgentList from './amuAgentList'
import AMUAgentDashboard from './AmuAgentDashboard'
export default function Main({ handleTabchange, EditData }) {
    const [currentTab, setcurrentTab] = useState("main")
    const [data,setData] =useState("")

    const handlecurrentTab = (type) => {
            setcurrentTab(type)
    }

    const handleData = (value)=>{
        setData(value)
    }

    return (
        <>
            {
                currentTab == "main" ?
                    <Maindadhboard
                        handleTabchange={handleTabchange}
                        EditData={EditData}
                        handlecurrentTab={handlecurrentTab}
                        handleData={handleData}
                    />
                    : ""}
            {
                currentTab == "amuAgentList" ?
                    <AmuAgentList
                        EditData={EditData}
                        handlecurrentTab={handlecurrentTab}
                         handleData={handleData}
                    />
                    : ""}
            {
                currentTab == "AmuAgentDetail" ?
                    <AMUAgentDashboard
                        EditData={EditData}
                        InfoDataId={data}
                        handlecurrentTab={handlecurrentTab}
                    />
                    : ""}
        </>
    )
}
